import styled from "styled-components";

export const IconChipSmall = styled.div`
  display: flex;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.secondary};
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
`;

export const IconChipMedium = styled.div`
  display: flex;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background-color: ${({ theme }) => theme.colors.secondary};
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
`;

export const IconChipLarge = styled.div`
  display: flex;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background-color: ${({ theme }) => theme.colors.secondary};
  width: 46px;
  height: 46px;
  justify-content: center;
  align-items: center;
`;

export const Flex = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
`;
